import React from "react";

export default class DialogOverlay extends React.Component {
    constructor (props) {
        super(props);

        this.hotkeys = {
            "enter": () => this.props.onSubmit(),
            "esc": () => this.props.onCancel(),
        };
    }

    componentDidMount () {
        this.props.hotkeyHandler.subscribe(this.hotkeys, this);
    }

    componentWillUnmount () {
        this.props.hotkeyHandler.unsubscribe(this.hotkeys, this);
    }

    render () {
        return (
            <div className="dialog-overlay" style={this.props.style}>
                <div className="row text-outline transparent-black-bg" style={{
                    border: "solid 1px rgba(255,255,255,0.75)",
                    borderRadius: "4px",
                    padding: "8px",
                }}>
                    <div className="row">
                        <div className="col-xs-12 text-very-large">
                            {this.props.children}
                        </div>
                        <div className="col-xs-12" style={{marginTop: "8px"}}>
                            <div className="btn-group btn-group-lg btn-group-justified">
                                <a  onClick={this.props.onSubmit}
                                    className="btn btn-default btn-transparent text-outline">
                                    <b>{this.props.submitText}</b>
                                </a>
                                {this.props.onSecondarySubmit !== undefined &&
                                    <a  onClick={this.props.onSecondarySubmit}
                                        className="btn btn-default btn-transparent text-outline">
                                        <b>{this.props.secondarySubmitText}</b>
                                    </a>
                                }
                                {this.props.onCancel !== undefined &&
                                    <a onClick={this.props.onCancel}
                                       className="btn btn-default btn-transparent text-outline">
                                        <b>{this.props.cancelText}</b>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DialogOverlay.defaultProps = {
    style: {},
    submitText: "Save",
    secondarySubmitText: null,
    cancelText: "Discard",
};



// WEBPACK FOOTER //
// ./src/js/DialogOverlay.js